import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import {
  Link,
  Switch,
  Route
} from 'react-router-dom'

import WebVR from './WebVR'

import './projects.css'

class Projects extends Component {
  render() {

    const { match } = this.props;

    console.warn('match', match)
    return (
      <div className="projects">
        <Route path={`${match.url}/webvr`} component={WebVR}/>
        <Route exact path={match.url} render={() => (
          <div>
            <span className="header">webgl + webvr</span>
            <div>
              <Link to={`${match.url}/webvr`}>
                WebVR boilerplate
              </Link> - various projects in WebVR
            </div>
            <br />
            <span className="header">hardware</span>
            <div>
              <Link to="/blog">see blog</Link> - or <Link to="/about">twitter</Link> - or <Link to="/about">github</Link>
            </div>
          </div>
        )}/>

      </div>
    )

  }
}

export default Projects



// WEBPACK FOOTER //
// ./src/components/Projects/index.js